import CrudCustom from '../../../libs/custom/CrudCustom';

let PerusahaanService = new CrudCustom('/perusahaans');
export default PerusahaanService;
